// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"b3ba0f14","564":"b3ba0f14","624":"b3ba0f14","779":"b3ba0f14","880":"b3ba0f14"}[chunkId] + ".chunk.css";
};